import { Component, OnInit } from '@angular/core';
declare var $;

@Component({
  selector: 'app-reporte-resumen-de-obra-grupos-modal',
  templateUrl: './reporte-resumen-de-obra-grupos-modal.component.html',
  styleUrls: ['./reporte-resumen-de-obra-grupos-modal.component.scss']
})
export class ReporteResumenDeObraGruposModalComponent implements OnInit {

  modalTitle: string = "";
  grupos: any[] = [];
  obra: any = {};
  constructor() { }

  ngOnInit() {
  }


  close(){
    $('#reporte-resumen-de-obra-grupos-modal').modal('hide');
  }

  open(data) {
    this.fill(data);
    $('#reporte-resumen-de-obra-grupos-modal').modal('show');
  }

  fill(data) {
    console.log('data modal ', data);
    this.modalTitle = data.modalTitle;
    this.grupos = data.grupos;
    this.obra = data.obra;
  }

  getTipoMovimiento( movimiento ) {
    if (movimiento.conceptos.traspaso == 1) {
      return 'TRASPASO';
    }
    
    return (movimiento.tipoMovimiento == 2) ? 'INGRESO' : 'EGRESO';
  }

  isTraspasoIngreso(movimientoObra) {

    if (!movimientoObra.conceptos) {
      return false;
    }
    const isTraspasoIngreso = (movimientoObra.conceptos.traspaso == 1 && movimientoObra.tipoMovimiento == 2)? true: false;
    return isTraspasoIngreso;
  }

  isTipoMovimiento( tipoMovimiento, movimiento = null) {
    if (!movimiento) {
      return false;
    }

    if (tipoMovimiento == 4 && movimiento.conceptos.traspaso == 1) {
      return true;
    }
    if (tipoMovimiento == movimiento.tipoMovimiento && movimiento.conceptos.traspaso != 1) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/reporte-resumen-de-obra/reporte-resumen-de-obra-grupos-modal/reporte-resumen-de-obra-grupos-modal.component.ts